const { gsap } = require('gsap/dist/gsap');
const { ScrollTrigger } = require('gsap/dist/ScrollTrigger');
const scrollAnimate = require('base/components/scrollAnimate');
const base = require('./base');
const readmore = require('../components/readmore');

gsap.registerPlugin(ScrollTrigger);

/**
 * Enable/disable UI elements
 * @param {boolean} enableOrDisable - true or false
 */
function updateAddToCartEnableDisableOtherElements(enableOrDisable) {
    $('button.add-to-cart-global').attr('disabled', enableOrDisable);
}

function togglePriceInput() {
    const $this = $(this);
    const $input = $this.find('.js-price-option-input');
    const $allInputs = $('.js-price-option-input');

    $('.js-price-option').removeClass('active');
    $allInputs.prop('checked', false);
    $this.addClass('active');
    $input.prop('checked', true);
}

function animateLeaf() {
    const $leaves = $('.product-detail__leaves');

    if (!$leaves || $leaves.length <= 0) {
        return;
    }

    gsap.to($leaves, {
        yPercent: -100,
        ease: 'none',
        scrollTrigger: {
            trigger: $('.js-qty-container'),
            scrub: true,
        },
    });

    gsap.timeline({ repeat: -1 })
        .to($leaves, { rotation: -3, duration: 2 })
        .to($leaves, { rotation: 3, duration: 2 });
}

function bindEvents() {
    readmore.init(3);

    // Price Options
    $('.js-price-option').on('click.toggle', togglePriceInput);

    // Accolades
    const $target = $('.js-target-accolade:not(.d-md-none)').first();

    if (!$target || $target.length <= 0) {
        return;
    }

    $('.js-goto-accolades').on('click', scrollAnimate.bind(null, $target));
}

module.exports = {
    methods: {
        updateAddToCartEnableDisableOtherElements,
    },

    availability: base.availability,
    addToCart: base.addToCart,

    updateAttributesAndDetails: () => {
        $('body').on('product:statusUpdate', (e, data) => {
            const $productContainer = $(`.product-detail[data-pid="${data.id}"]`);

            $productContainer.find('.description-and-detail .product-attributes')
                .empty()
                .html(data.attributesHtml);

            if (data.shortDescription) {
                $productContainer.find('.description-and-detail .description')
                    .removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .description .content')
                    .empty()
                    .html(data.shortDescription);
            } else {
                $productContainer.find('.description-and-detail .description')
                    .addClass('hidden-xl-down');
            }

            if (data.longDescription) {
                $productContainer.find('.description-and-detail .details')
                    .removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .details .content')
                    .empty()
                    .html(data.longDescription);
            } else {
                $productContainer.find('.description-and-detail .details')
                    .addClass('hidden-xl-down');
            }
        });
    },

    showSpinner: () => {
        $('body').on('product:beforeAddToCart product:beforeAttributeSelect', () => {
            $.spinner().start();
        });
    },

    updateAttribute: () => {
        $('body').on('product:afterAttributeSelect', (e, response) => {
            if ($('.product-detail>.bundle-items').length) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else if ($('.product-set-detail').eq(0)) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else {
                $('.product-id').text(response.data.product.id);
                $('.product-detail:not(".bundle-item")').data('pid', response.data.product.id);
            }
        });
    },

    updateAddToCart: () => {
        $('body').on('product:updateAddToCart', (e, response) => {
            // update local add to cart (for sets)
            $('button.add-to-cart', response.$productContainer)
                .attr('disabled', (!response.product.readyToOrder || !response.product.available));

            const enable = $('.product-availability').toArray().every((item) => $(item).data('available') && $(item).data('ready-to-order'));
            module.exports.methods.updateAddToCartEnableDisableOtherElements(!enable);
        });
    },

    updateAvailability: () => {
        $('body').on('product:updateAvailability', (e, response) => {
            $('div.availability', response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available);

            $('.availability-msg', response.$productContainer)
                .empty().html(response.message);

            if ($('.global-availability').length) {
                const allAvailable = $('.product-availability').toArray()
                    .every((item) => $(item).data('available'));

                const allReady = $('.product-availability').toArray()
                    .every((item) => $(item).data('ready-to-order'));

                $('.global-availability')
                    .data('ready-to-order', allReady)
                    .data('available', allAvailable);

                $('.global-availability .availability-msg').empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            }
        });
    },

    sizeChart: () => {
        $('.size-chart a').on('click', function (e) {
            e.preventDefault();
            const url = $(this).attr('href');
            const $prodSizeChart = $(this).closest('.size-chart').find('.size-chart-collapsible');
            if ($prodSizeChart.is(':empty')) {
                $.ajax({
                    url,
                    type: 'get',
                    dataType: 'json',
                    success: (data) => {
                        $prodSizeChart.append(data.content);
                    },
                });
            }
            $prodSizeChart.toggleClass('active');
        });

        const $sizeChart = $('.size-chart-collapsible');
        $('body').on('click touchstart', (e) => {
            if ($('.size-chart').has(e.target).length <= 0) {
                $sizeChart.removeClass('active');
            }
        });
    },

    copyProductLink: () => {
        $('body').on('click', '#fa-link', (event) => {
            event.preventDefault();
            const $temp = $('<input>');
            $('body').append($temp);
            $temp.val($('#shareUrl').val()).select();
            document.execCommand('copy');
            $temp.remove();
            $('.copy-link-message').attr('role', 'alert');
            $('.copy-link-message').removeClass('d-none');
            setTimeout(() => {
                $('.copy-link-message').addClass('d-none');
            }, 3000);
        });
    },

    bindEvents,
    animateLeaf,
    focusChooseBonusProductModal: base.focusChooseBonusProductModal(),
};
